module.exports = __webpack_public_path__ + "static/he-f0060c0d1e2debf7d5f2335c55e2a8aa.gif";